export const BRAND_NAME = 'OVERLAND TRACES';
